export interface ElectionPartyResult {
  partyAcronym: string;
  seats: number;
  percentage: number;
  votes: number;
}

export interface RegionElectionResult {
  region: string;
  totalSeats: number;
  results: ElectionPartyResult[];
}

export interface ElectionConfig {
  titleFr: string;
  titleAr: string;
  subtitleFr: string;
  subtitleAr: string;
  externalUrl: string;
  autoUpdate: boolean;
  isResultsNightActive?: boolean;
}

export interface NationalElectionResult {
  totalSeats: number;
  config: ElectionConfig;
  results: ElectionPartyResult[];
  resultsByRegion: RegionElectionResult[];
  lastUpdate: string;
}

const STORE_KEY = "kaynin_election_results";

export function getMockElectionData(): NationalElectionResult {
  return {
    totalSeats: 395,
    config: {
      titleFr: "Hémicycle : Projections en temps réel",
      titleAr: "التشكيلة المرتقبة لمجلس النواب",
      subtitleFr: "Suivez le dépouillement et la répartition provisoire des sièges à la chambre des représentants.",
      subtitleAr: "تابعوا فرز الأصوات وتوزيع المقاعد على المباشر.",
      externalUrl: "",
      autoUpdate: false,
      isResultsNightActive: false,
    },
    lastUpdate: new Date().toISOString(),
    results: [
      { partyAcronym: "RNI", seats: 102, percentage: 25.8, votes: 1205000 },
      { partyAcronym: "PAM", seats: 87, percentage: 22.0, votes: 1050000 },
      { partyAcronym: "PI", seats: 81, percentage: 20.5, votes: 980000 },
      { partyAcronym: "USFP", seats: 34, percentage: 8.6, votes: 410000 },
      { partyAcronym: "MP", seats: 28, percentage: 7.1, votes: 340000 },
      { partyAcronym: "PJD", seats: 13, percentage: 3.3, votes: 160000 },
      { partyAcronym: "PPS", seats: 22, percentage: 5.6, votes: 270000 },
      { partyAcronym: "UC", seats: 18, percentage: 4.6, votes: 220000 },
      { partyAcronym: "AUTRES", seats: 10, percentage: 2.5, votes: 120000 },
    ],
    resultsByRegion: [
      // simplified for mock
    ],
  };
}

export function getElectionResults(): NationalElectionResult {
  try {
    const raw = localStorage.getItem(STORE_KEY);
    if (raw) return JSON.parse(raw);
  } catch (e) {
    console.error("Failed to parse election results", e);
  }
  return getMockElectionData();
}

export function saveElectionResults(data: NationalElectionResult) {
  localStorage.setItem(STORE_KEY, JSON.stringify(data));
  window.dispatchEvent(new CustomEvent("electionResultsUpdated"));
}
